import { createElement } from 'react';
import { createRoot, RootOptions } from 'react-dom/client';
import { ModulesProviders } from './providers';

/**
 * Создает корневой элемент React и выполняет рендеринг приложения.
 * Автоматически оборачивает элемент в провайдеры модулей перед рендерингом.
 *
 * @param container - DOM-элемент или фрагмент документа, в котором будет выполнен рендеринг
 * @param element - React-элемент для рендеринга
 * @param options - Опции создания корневого элемента
 * @returns React Root
 *
 * @example
 * ```tsx
 * import { renderRoot } from '@adv-frontend/modules-render/client';
 * import App from './App';
 *
 * const container = document.getElementById('root');
 * const root = renderRoot(container, <App />);
 *
 * // Позже можно обновить корневой компонент
 * root.render(<App newProp="value" />);
 *
 * // Или размонтировать приложение
 * root.unmount();
 * ```
 */
export function renderRoot(container: Element | DocumentFragment, element: JSX.Element, options?: RootOptions) {
    const wrappedElement = createElement(ModulesProviders, null, element);
    const root = createRoot(container, options);
    root.render(wrappedElement);
    return root;
}

export type { Root, RootOptions } from 'react-dom/client';
